import '../scss/filters.scss';

jQuery(function ($) {
    const mobileWidth = 786;
    let isMobile = true;

    $(document).on('click', '[data-open-product-filters]', function () {
        $('.wcpf-filter').addClass('slide-in')
    });

    $(document).on('click', '[data-close-product-filters]', function () {
        $(document).triggerHandler('closeProductFilters');
    });

    $(document)
        .on('closeProductFilters', function () {
            $('.wcpf-filter').removeClass('slide-in')
        })

    $(window)
        .resize(function () {
            isMobile = $(this).width() < mobileWidth;

            if (!isMobile) {
                $(document).trigger('closeProductFilters');
            }
        })
        .resize()
        .on('wcpf_after_ajax_filtering', function () {
            const productsGrid = $('.products.grid ')
            const top = $('#top')

            $('html,body').animate({
                scrollTop: productsGrid.offset().top - top.outerHeight() - 100,
            }, 300)
        })
});
